
const GetPageUrl = () => { return window.location.href.split("/").filter(Boolean).pop(); };
const GetLastTwoUrl = () => { return window.location.href.split("/").filter(Boolean).slice(-2).join("/"); };
const GetLastThreeUrl = () => { return window.location.href.split("/").filter(Boolean).slice(-3).join("/"); };

export { GetPageUrl, GetLastTwoUrl, GetLastThreeUrl };
